import React, { ReactElement } from 'react';
import { Loading } from '@dexma/ui-components';
import WidgetTypePreset from 'adapter/in/common/components/WidgetTypePreset';
import useWidgetTypePresetContainer from 'adapter/in/common/widget/WidgetTypePreset/useWidgetTypePresetContainer';
import { StyledConfigFieldGroup } from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration/style';

const WidgetTypePresetContainer = (): ReactElement => {
    const { presetWidgetTypes, onWidgetSelect } = useWidgetTypePresetContainer();

    return presetWidgetTypes ? (
        <StyledConfigFieldGroup fluid>
            <WidgetTypePreset presetWidgetTypes={presetWidgetTypes} onWidgetClick={onWidgetSelect} />
        </StyledConfigFieldGroup>
    ) : (
        <Loading isLoading size={50} />
    );
};

export default WidgetTypePresetContainer;
